import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

// 查询条件卡片：适合页面顶部的“学年、学期、状态、姓名”等筛选区域。
// fields 中每一项就是一个筛选字段，产品侧增加字段时优先改页面里的 fields 数组。
export default function FilterCard({ fields, expandable = false }) {
  const [isExpanded, setIsExpanded] = useState(!expandable);

  return (
    <div className="bg-white p-4 rounded shadow-sm mb-4 border border-gray-100 transition-all duration-300">
      <div className="flex flex-wrap gap-x-6 gap-y-4">
        {fields.map((f, i) => (
          <div key={i} className={`flex flex-col space-y-1.5 ${!isExpanded && i > 2 ? 'hidden' : 'block'}`}>
            <span className="text-[13px] text-gray-500">{f.label}</span>

            {f.type === 'select' ? (
              <select className="border border-gray-300 rounded px-3 py-1.5 min-w-[150px] outline-none focus:border-[#1890ff] text-[13px] text-gray-700 bg-white">
                {f.options.map(opt => <option key={opt}>{opt}</option>)}
              </select>
            ) : f.type === 'radio' ? (
              <div className="flex space-x-4 h-[32px] items-center px-1">
                {f.options.map(opt => (
                  <label key={opt} className="flex items-center space-x-1.5 cursor-pointer text-[13px] text-gray-700">
                    <input type="radio" name={`filter_${f.label}`} defaultChecked={opt === f.defaultValue} className="form-radio text-[#1890ff] focus:ring-[#1890ff]" />
                    <span>{opt}</span>
                  </label>
                ))}
              </div>
            ) : (
              <input
                type="text"
                placeholder={f.placeholder ? (f.placeholder.startsWith('请输入') ? f.placeholder : `请输入${f.placeholder}`) : '请输入...'}
                className="border border-gray-300 rounded px-3 py-1.5 w-48 outline-none focus:border-[#1890ff] text-[13px] text-gray-700 placeholder-gray-400"
              />
            )}
          </div>
        ))}

        <div className="flex space-x-3 ml-auto mt-auto pb-0.5">
          {expandable && (
            <button onClick={() => setIsExpanded(!isExpanded)} className="text-[#1890ff] text-[13px] flex items-center hover:underline mr-2">
              {isExpanded ? <>收起 <ChevronUp size={14} className="ml-0.5" /></> : <>展开 <ChevronDown size={14} className="ml-0.5" /></>}
            </button>
          )}
          <button className="px-4 py-1.5 border border-gray-300 text-gray-700 rounded text-sm hover:bg-gray-50 transition-colors">重置</button>
          <button className="px-4 py-1.5 bg-[#1890ff] text-white rounded text-sm hover:bg-[#096dd9] transition-colors">查询</button>
        </div>
      </div>
    </div>
  );
}
